import store from "@/store";
import bugsnagClient from "@/plugins/bugsnag";
/**
 * Ensures that everything is created
 * @param {*} to
 * @param {*} from
 * @param {*} next
 */
async function debug(to, from, next) {
  next();
  let user = {
    organization: store.getters.getOrganization.name
  };
  let aws_user = JSON.parse(JSON.stringify(store.getters.getAWSUser));
  let reg_user = JSON.parse(JSON.stringify(store.getters.getUser));

  //   console.log("Debug", aws_user);
  if (store.getters.getAWSUser) {
    // console.log("Passed");
    user = {
      username: aws_user.username,
      email: aws_user.attributes.email,
      sub: aws_user.attributes.sub,
      uid: reg_user._id,
      ...user
    };
  }
  //add user
  bugsnagClient.user = user;

  //add vue stuff
}
export default debug;
